<template>
  <div class="container">
    <div class="top">
      <!--      <img src="@/assets/bg.png"/>-->
      <p>兑换专区</p>
    </div>

    <div class="form-container">
      <van-field class="input" v-model="duihuancode"
                 name="duihuancode"
                 :rules="[{ required: true, message: '请输入兑换码' }]"
                 placeholder="请输入兑换码"/>
      <van-field class="input" v-model="yzm"
                 name="yzm"
                 :rules="[{ required: true, message: '请输入激活码' }]"
                 placeholder="请输入激活码"/>


      <van-button @click="duihuan_click()" class="exchange">立即兑换</van-button>
      <van-button v-on:click="showmyqrcode()" class="showmyqrcode">查看我的兑换码</van-button>
      <van-button v-on:click="showmyqrorder()" class="showmyqrcode showmyqrcode2">查看我的订单</van-button>

    </div>
    <div class="desription">
      <div>活动说明:</div>
      <div>1、本次活动最终解释权归易点点水果商城所有</div>
      <div>2、活动时间请参考实体兑换券</div>
    </div>
    <cube-view></cube-view>
  </div>
</template>

<script>
import CubeView from '@/components/TP/cube-view'
import * as util from '@/utils/network'
import { Dialog } from 'vant';

export default {
  name: "Actxchange",
  components: {
    CubeView,
  },
  data() {
    return {
      qrcodedata: null,
      duihuancode: '',
      yzm: '',
    }
  },
  methods: {
    showmyqrcode:function (){
      this.$router.push({path: 'showactmy/showacthistory',query: {token: this.$route.query.token}})
    },
    showmyqrorder:function (){
      this.$router.push({path: 'showactmy/showactmyorder',query: {token: this.$route.query.token}})
    },
    duihuan_click: function () {
    if (this.duihuancode.length<5){
      Dialog.alert({
        title: '温馨提示',
        message: "请输入兑换码"
      });
      return
    }if (this.yzm.length<4){
      Dialog.alert({
        title: '温馨提示',
        message: "请输入激活码"
      });
      return
    }

      //这里根据code 和 userid  兑换 二维码
      var url = "/addons/qrcodeshop/api.code/nowduihuan"
      let that = this;
      util.post(url, {code: that.duihuancode,yzm:that.yzm},
          function (result) {

            console.log(result);
            //兑换成功后 自动跳转
           that.$router.push({path: 'Showactgoodlist', query: {actid: result.data.activity_id}})
          },
      );
    },
  }
}
</script>

<style scoped>

.container {
  width: 100%;
  height: 100vh;
  background: #FF9159 url("../assets/bg.jpg") no-repeat;
  background-size: 100% 100%;
}

.container .top {
  height: 240px;
}

.container .top p {
  margin: 0;
  padding: 0;
  font-size: 60px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  padding-top: 60px;
}

.form-container {
  width: 80%;
  margin: 0 auto;
}

.form-container .input {
  border-radius: 80px;
  margin-top: 20px;
  box-shadow: 2px 2px 8px rgba(18, 131, 255, 0.3);
}

.form-container .exchange {
  width: 100%;
  height: 40px;
  /*background: #FF9259;*/
  background: #FEE500;
  box-shadow: 2px 2px 8px rgba(18, 131, 255, 0.3);
  opacity: 1;
  margin: 1em auto;
  display: block;
  margin-top: 30px;
  border-radius: 80px;
  color: #F00815;
  font-weight: bold;
}


.form-container .showmyqrcode {
  width: 100%;
  height: 40px;
  background: #FF9259;
  box-shadow: 2px 2px 8px rgba(18, 131, 255, 0.3);
  opacity: 1;
  margin: 1em auto;
  display: block;
  margin-top: 20px;
  border-radius: 80px;
  color: #ffffff;
  font-weight: bold;
}
.form-container .showmyqrcode2 {
  background:#F36855;
}

.desription {
  width: 80%;
  margin: 4rem auto;
  font-size: 12px;
  color: #ffffff;
}
</style>